module.exports = __webpack_public_path__ + "00d98fb6c42e0088b9dc5823f3843baf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-kawauso-omedetou.png
// module id = 2043
// module chunks = 4